<template>
  <div class="bn-wrap">
    <div v-if="!headBanner" class="bn-container">
      <div class="bn-bd">
        <h2 v-if="title" v-html="title" />
      </div>
    </div>
    <img v-if="headBanner" :src="headBanner" :alt="title">
    <div v-if="insuranceLabelPosition === 'legacy'" class="default-infor">
      <div v-if="insuranceInfor.companyName" class="company-name after-bdr">
        {{ insuranceInfor.companyName }}
      </div>
      <div v-if="insuranceInfor.name" class="insurance-name">
        {{ insuranceInfor.name }}
      </div>
    </div>
    <a
      v-if="showCompanyIntroduction"
      class="company-itr"
      data-stat-id="JHS_JGY_GSJS"
      href="javascript:void(0)"
      @click="handleCompanyIntroductionUrl"
    >
      <span>{{ (insuranceInfor.companyName + '介绍') || '公司介绍' }}</span>
      <i class="iconfont icon-arrows_right" />
    </a>
    <header
      v-if="insuranceLabelPosition === 'bottom'"
      class="insurance-name"
      :class="{ 'with_bg': bannerNameBg }"
      :style="{ backgroundColor: bannerNameBg }"
    >
      {{ textOverflowEllipsis(insuranceInfor.name, 18) }}
    </header>
  </div>
</template>

<script>
import { textOverflowEllipsis } from '@/common/utils/index'
import { URL_PARAM, APP_CHANNEL } from '@/common/utils/variables'
const { shareFrom } = URL_PARAM
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headBanner: {
      type: String,
      default: '',
    },
    insuranceInfor: {
      type: Object,
      default() {
        return {}
      },
    },
    insuranceLabelPosition: {
      type: String,
      default: 'none',
      validator: val => ['none', 'legacy', 'bottom'].includes(val)
    },
    bannerNameBg: String,
  },
  data() {
    return {
      shareFrom,
      APP_CHANNEL,
    }
  },
  computed: {
    showCompanyIntroduction() {
      const { insuranceInfor } = this;
      return Boolean(insuranceInfor.companyIntroductionUrl) && !['H5_BXZ'].includes(APP_CHANNEL);
    }
  },
  methods: {
    textOverflowEllipsis,
    handleCompanyIntroductionUrl() {
      const { insuranceInfor } = this
      const { shareFrom, app } = URL_PARAM
      if(insuranceInfor.companyIntroductionUrl && (shareFrom || app)) {
        window.location.href = `${insuranceInfor.companyIntroductionUrl}&shareFrom=${shareFrom || app}`
      } else {
        window.location.href = insuranceInfor.companyIntroductionUrl
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.bn-wrap {
  overflow: hidden;
  position: relative;
  width: 100%;
  & .company-itr {
    & span,
    & i {
      vertical-align: middle;
    }
    & i {
      margin-left: 3px;
    }
    & .vip-tag {
      position: absolute;
      top: -4px;
      left: -8px;
      width: 18px;
      height: 18px;
      vertical-align: middle;
    }
  }
  .bn-container {
    overflow: hidden;
    height: 115px;
  }
  img {
    width: 100%;
    vertical-align: middle;
  }
  .default-infor {
    padding-left: 18px;
    padding-right: 145px;
    & .company-name {
      font-size: 15px;
      padding: 3px 6px;
      margin-bottom: 9px;
    }
    & .insurance-name {
      font-size: 17px;
      font-weight: bold;
      line-height: 1.5;
    }
  }
  .bn-bd {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 115px;
    padding-top: 8px;
    text-align: center;
    color: #fff;
    h2 {
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 90%;
      max-height: 88px;
      transform: translate(-50%, -50%);
      margin-top: -11px;
      font-size: 24px;
    }
  }
}
</style>
<style lang="less">
.theme-banner {
  & .insurance-name {
    position: absolute;
    font-size: 17px;
    font-weight: bold;
    color: #fff;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 16.56%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & .insurance-name.with_bg {
    right: 0;
    width: auto;
    margin: 0 15px;
    border-radius: 100px;
  }
}
</style>
